import { z } from 'zod';

type IssuePersonalStorySchema = z.ZodObject<{
	issue: z.ZodString;
	personalStory: z.ZodDefault<z.ZodOptional<z.ZodString>>;
}>;

export function buildIssuePersonalStorySchema(requiredIssueMessage: string): IssuePersonalStorySchema {
	return z.object({
		issue: z.string({ message: requiredIssueMessage }).min(1, { message: requiredIssueMessage }),
		personalStory: z.string().optional().default(''),
	});
}
